<template>
  <div class="card-body-312  ">

    <img class="card-body-312-img rounded" :src="image" :alt="alt">

    <slot name="p-1">
      <p class="pt-3 card-body-312-title  text-right">گوشی موبایل اپل مدل iPhone 13 CH/A Not Active ظرفیت 128
        گیگابایت - رم 4 گیگابایت </p>
    </slot>

    <div class="row">
      <div class="col-4">

        <slot name="p-3">
          <span class="bg-danger py-1 px-2 rounded text-white p">%2</span>
        </slot>

      </div>
      <div class="col-8 text-left ">
        <slot name="p-2">

          <p class="text-left m-0 p-0  ">43,399,000</p>
          <del class="text-left m-0 p-0  ">43,399,000</del>
        </slot>
      </div>
    </div>

  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card312",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },

}

</script>

<style scoped>
.card-body-312 {
  padding-left: 10px;
  min-height: 420px;
  border-left: 1px solid rgb(231, 231, 231);
  border-bottom: 1px solid rgb(231, 231, 231);
}

.card-body-312-img {
  aspect-ratio: 1 / 1;
  object-fit: cover;
  width: 100%;
}
</style>